import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SFAccount } from '@shared/entities/sf-account';
import { AccountSFContactIdService } from '@shared/services/api/account-sfcontact-id.service';
import { first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-accounts-selection',
  templateUrl: './accounts-selection.component.html',
  styleUrl: './accounts-selection.component.scss'
})
export class AccountsSelectionComponent implements OnChanges, OnDestroy {
  @Input() form!: FormGroup;
  @Input() isCurrentUserAdmin = false;
  @Input() isLight = true;
  @Input() sfContactId = '';
  @Input() isPartner = false;
  @Input() isEdit = false;
  @Input() existingAccounts: SFAccount[] = [];

  availableAccounts: SFAccount[] = [];
  contactAccount: SFAccount = new SFAccount();

  @Output() accountSelectionChange = new EventEmitter<{ account: SFAccount; checked: boolean }>();
  @Output() accountsLoaded = new EventEmitter<SFAccount[]>();

  private destroy$ = new Subject<void>();

  constructor(private _accountSFContactIdService: AccountSFContactIdService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['sfContactId'] && this.sfContactId && this.isPartner) {
      this.loadContactAccount(this.sfContactId);
    }

    if (changes['existingAccounts'] && this.isEdit) {
      const current = JSON.stringify(this.existingAccounts || []);
      const previous = JSON.stringify(changes['existingAccounts'].previousValue || []);

      if (current !== previous && this.existingAccounts && this.existingAccounts.length > 0) {
        this.availableAccounts = this.existingAccounts;
        this.form.patchValue({ selectedAccounts: this.existingAccounts });
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isAccountSelected(account: SFAccount): boolean {
    const selected = this.form.get('selectedAccounts')?.value || [];
    return selected.some((a: SFAccount) => a.id === account.id);
  }

  onAccountSelection(account: SFAccount, checked: boolean): void {
    this.accountSelectionChange.emit({ account, checked });
  }

  private loadContactAccount(contactId: string): void {
    if (!contactId) return;

    this._accountSFContactIdService
      .getAccountByContactId(contactId)
      .pipe(first(), takeUntil(this.destroy$))
      .subscribe((account) => {
        if (account) {
          this.contactAccount = account;

          if (this.isPartner) {
            this.availableAccounts = [account];

            const currentAccounts = this.form.get('selectedAccounts')?.value || [];
            if (!this.isEdit || currentAccounts.length === 0) {
              this.form.patchValue({
                selectedAccounts: [account]
              });
            }

            this.accountsLoaded.emit([account]);
          }
        }
      });
  }
}
